import { render, staticRenderFns } from "./StackView.vue?vue&type=template&id=278fb70d&scoped=true&"
import script from "./StackView.vue?vue&type=script&lang=js&"
export * from "./StackView.vue?vue&type=script&lang=js&"
import style0 from "./StackView.vue?vue&type=style&index=0&id=278fb70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278fb70d",
  null
  
)

export default component.exports